import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { allapiAction } from "../../Redux/common/action";
import { URL } from "../../Redux/common/url";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { Navigation, Pagination } from "swiper/modules";
// import { Navigation, Pagination } from "swiper";
function BlogListpub2() {
  // getBlogListPub
  const navigate = useNavigate();
  const blog_list = useSelector((state) =>
    state?.allapi?.blog_list ? state?.allapi?.blog_list : {}
  );
  const get_blog_category_list = useSelector((state) =>
    state?.allapi?.get_blog_category_list
      ? state?.allapi?.get_blog_category_list
      : []
  );
  const get_recent_blog_list = useSelector((state) =>
    state?.allapi?.get_recent_blog_list
      ? state?.allapi?.get_recent_blog_list
      : []
  );

  console.log(get_recent_blog_list);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(allapiAction.getBlogListPub(1));
    // dispatch(allapiAction.getblogcateAllList({}));
    dispatch(allapiAction.getrectentBlog({}));

    return () => {};
  }, []);

  return (
    <div>
      {" "}
  <div className="page-title py-5 text-center bg-light">
  <div className="container">
    <h1 className="fw-bold display-5 text-uppercase mb-2">BLOG</h1>
    <p className="text-muted lead">
      Discover the latest updates, news, and insights from our team.
    </p>
  </div>
</div>

<div className="container mt-5">
  <div className="row">
    <div className="col-12">
      {blog_list?.docs && (
        <Swiper
          spaceBetween={20}
          slidesPerView={1}
          navigation
          pagination={{ clickable: true }}
          breakpoints={{
            768: { slidesPerView: 2 },
            992: { slidesPerView: 3 },
          }}
          modules={[Navigation, Pagination]}
        >
          {blog_list.docs.map((data, i) => (
            <SwiperSlide key={i}>
              <div
                className="blog-card shadow rounded overflow-hidden mb-4"
                style={{
                  maxWidth: "95%",
                  margin: "auto",
                  background: "#fff",
                  borderRadius: "12px",
                  overflow: "hidden",
                  transition: "transform 0.3s ease",
                }}
              >
                {/* ✅ Image Section */}
                <div
                  className="blog-img-wrap"
                  style={{
                    width: "100%",
                    height: "240px", // fixed image height
                    overflow: "hidden",
                    position: "relative",
                  }}
                >
                  <img
                    src={URL?.API_BASE_URL + data?.feature_image}
                    className="img-fluid blog-img"
                    alt={data?.title}
                    onClick={() => navigate("/blog-details/" + data?.slug)}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover", // properly crops any image
                      transition: "transform 0.4s ease",
                      cursor: "pointer",
                    }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.transform = "scale(1.07)")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.transform = "scale(1)")
                    }
                  />
                </div>

                {/* ✅ Content Section */}
                <div
                  className="p-4 bg-white"
                  style={{
                    padding: "1.5rem 1.3rem",
                    textAlign: "left",
                  }}
                >
                  <p
                    className="text-muted small mb-1"
                    style={{
                      fontSize: "0.85rem",
                      marginBottom: "0.6rem",
                      color: "#888",
                    }}
                  >
                    <i className="fa fa-calendar accent-color"></i>&nbsp;
                    {moment(data?.createdAt).format("MMM DD, YYYY")}
                  </p>

                  <h3
                    className="fw-bold blog-title mb-2"
                    onClick={() => navigate("/blog-details/" + data?.slug)}
                    style={{
                      fontSize: "1.25rem",
                      lineHeight: "1.4",
                      cursor: "pointer",
                      color: "#222",
                      marginBottom: "0.75rem",
                    }}
                  >
                    {data?.title}
                  </h3>

                  <p
                    className="text-secondary"
                    onClick={() => navigate("/blog-details/" + data?.slug)}
                    style={{
                      cursor: "pointer",
                      fontSize: "0.95rem",
                      color: "#555",
                      lineHeight: "1.6",
                      marginBottom: "1rem",
                    }}
                  >
                    {data?.short_description}
                  </p>

                  <button
                    type="button"
                    onClick={() => navigate("/blog-details/" + data?.slug)}
                    style={{
                      background: "#28a745",
                      color: "#fff",
                      border: "none",
                      borderRadius: "8px",
                      padding: "8px 18px",
                      fontSize: "0.9rem",
                      fontWeight: "600",
                      cursor: "pointer",
                      transition: "background 0.3s ease",
                    }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.background = "#218838")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.background = "#28a745")
                    }
                  >
                    Read More →
                  </button>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </div>
  </div>
</div>





    </div>
  );
}

export default BlogListpub2;
